<template>
  <div id="page-statistic">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex sm12>
          <h2>Overview</h2>
        </v-flex>
        <!-- mini statistic start -->
        <v-flex lg3 sm6 xs12>
          <mini-statistic
            icon="fa fa-building-o"
            :title="counterCard"
            sub-title="C O M P A N I E S"
            color="indigo"
          ></mini-statistic>
        </v-flex>
        <v-flex lg3 sm6 xs12>
          <mini-statistic
            icon="fa fa-toggle-on"
            :title="activesCard"
            sub-title="A C T I V E S"
            color="indigo"
          ></mini-statistic>
        </v-flex>
        <v-flex lg3 sm6 xs12>
          <mini-statistic
            icon="fa fa-pencil-square-o"
            :title="registersCard"
            sub-title="R E G I S T E R S"
            color="blue"
          ></mini-statistic>
        </v-flex>
        <v-flex lg3 sm6 xs12>
          <mini-statistic
            icon="fa fa-user-circle-o"
            :title="accountsCard"
            sub-title="A C C O U N T S"
            color="blue"
          ></mini-statistic>
        </v-flex>
      </v-layout>
      <p></p>
      <v-layout row wrap>
        <v-flex sm4>
          <h4>Providers Percentage</h4>
          <Gradient></Gradient>
        </v-flex>
        <v-flex sm8>
          <h4>Providers per Activity</h4>
          <BarGroup></BarGroup>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import MiniStatistic from "@/components/widgets/statistic/MiniStatistic"
/*import LinearStatistic from "@/components/widgets/statistic/LinearStatistic"
import CircleStatistic from "@/components/widgets/statistic/CircleStatistic"*/
import BarGroup from "../../apexcharts/BarGroup"
import Gradient from "../../apexcharts/Gradient"

export default {
  components: {
    Gradient,
    BarGroup,
    MiniStatistic
  },
  data() {
    return {
      counterCard: window.counter,
      activesCard: window.actives,
      registersCard: window.registers,
      accountsCard: window.accounts
    }
  },
  beforeCreate() {
    const request = window.indexedDB.open("ioScience", window.version)
    request.onsuccess = function() {
      const db = request.result
      const transaction = db.transaction("factsQuery", "readwrite")
      const mapInfo = transaction.objectStore("factsQuery")
      const all = mapInfo.getAll()

      all.onsuccess = function() {
        var counterAll = all.result
        window.counter = counterAll[counterAll.length - 1].value["Facts.count"].toString()
        window.actives = counterAll[counterAll.length - 1].value["Facts.isActive"].toString()
        window.registers = counterAll[counterAll.length - 1].value["Facts.isRegistered"].toString()
        window.accounts = counterAll[counterAll.length - 1].value["Facts.hasAccount"].toString()
      }
    }
  }
}
</script>
<style lang="stylus" scoped></style>
